import { ServicePaymentPayloadDto, useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const QUERY_KEY = 'CREATE_SERVICE_PAYMENT';
export const SERVICE_CONFIGS_QUERY_KEY = 'GET_SERVICE_CONFIGS';

const useCreateServicePaymentQuery = (isUpdateMode?: boolean, id?: string) => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading } = useMutation(
    (payload: ServicePaymentPayloadDto) =>
      isUpdateMode
        ? api.put(`${API_URL.SERVICE_CONFIGS}/${id}`, payload)
        : api.post(API_URL.SERVICE_CONFIGS, payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [SERVICE_CONFIGS_QUERY_KEY],
        });
      },
    }
  );

  return { handleCreate: mutateAsync, isLoading };
};

export default useCreateServicePaymentQuery;
